<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row class="mb-1">
          <b-col cols="12" lg="4">
            <b-form-group label="Fecha" @click.prevent class="py-0 my-0">
              <b-input-group>
                <flat-pickr
                    v-model="fechaFiltro"
                    class="form-control"
                    :config="{wrap: true, mode: 'range', dateFormat: 'd/m/Y', locale: 'es'}"
                />
                <b-input-group-append>
                  <b-button
                      variant="gradient-danger"
                      @click="fechaFiltro = null"
                  >
                    <feather-icon
                        icon="Trash2Icon"
                    />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="4">
            <b-form-group label="Empresa" @click.prevent class="py-0 my-0">
              <v-select
                  id="empresa_filtro"
                  v-model="filtro[0].valor"
                  :options="empresaFiltro"
                  multiple
                  placeholder="Seleccionar empresa ..."
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="4">
            <b-form-group label="Sede" @click.prevent class="py-0 my-0">
              <v-select
                  id="sede_filtro"
                  v-model="filtro[1].valor"
                  :options="sedeFiltro"
                  multiple
                  placeholder="Seleccionar sede ..."
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-row class="mb-1">
          <b-col cols="12" lg="4">
            <b-form-group label="Área Responsable" @click.prevent class="py-0 my-0">
              <v-select
                  id="area_responsable_filtro"
                  v-model="filtro[2].valor"
                  :options="area_responsableFiltro"
                  multiple
                  placeholder="Seleccionar área ..."
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="4">
            <b-form-group label="Planilla" @click.prevent class="py-0 my-0">
              <v-select
                  id="planilla_filtro"
                  v-model="filtro[3].valor"
                  :options="planillaFiltro"
                  multiple
                  placeholder="Seleccionar planilla ..."
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="3">
            <b-form-group label="Unidad" @click.prevent class="py-0 my-0">
              <v-select
                  id="unidad_filtro"
                  v-model="filtro[4].valor"
                  :options="unidadFiltro"
                  multiple
                  placeholder="Seleccionar unidad ..."
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" lg="1">
            <b-form-group label="." @click.prevent class="py-0 my-0">
              <b-button
                  variant="gradient-primary"
                  @click="buscar"
                  block
              >
                <feather-icon
                    icon="SearchIcon"
                />
              </b-button>
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <b-card no-body>
      <b-card-body>
        <div class="hello" ref="chartdiv"></div>
        <div class="text-danger"> No se pudo cargar el gráfico, error de la librería Chart 5 </div>
      </b-card-body>
    </b-card>
  </div>

</template>

<script>

import axiosIns from '../../libs/axios'
import vSelect from 'vue-select'

import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';

import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BInputGroupAppend,
  BInputGroup,
  BButton,
  BFormGroup,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { Spanish } from "flatpickr/dist/l10n/es.js"

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BInputGroupAppend,
    BInputGroup,
    BButton,
    BFormGroup,
    flatPickr,
    vSelect,
  },
  directives: {
  },
  data: () => ({
    loading: false,
    items: [],
    itemsFiltro: [],

    fechaFiltro: null,

    empresaFiltro: [],
    sedeFiltro: [],
    planillaFiltro: [],
    unidadFiltro: [],
    area_responsableFiltro: [],

    empresa_filtro: [],
    sede_filtro: [],
    planilla_filtro: [],
    unidad_filtro: [],
    area_responsable_filtro: [],

    filtro: [
      {nombre: "empresa", valor: []},
      {nombre: "sede", valor: []},
      {nombre: "area_responsable", valor: []},
      {nombre: "planilla", valor: []},
      {nombre: "unidad", valor: []},
      {nombre: "fecha", valor: []}
    ],

    datos: [
      {
        category: "ADMINISTRACIÓN",
        programadas: 1000,
        ejecutadas: 588,
        p_cumplimiento: 10,
        p_meta: 85,
      },
      {
        category: "BIENESTAR SOCIAL",
        programadas: 1200,
        ejecutadas: 1800,
        p_cumplimiento: 30,
        p_meta: 85,
      },
      {
        category: "FOOD SAFETY",
        programadas: 850,
        ejecutadas: 1230,
        p_cumplimiento: 20,
        p_meta: 85,
      },
      {
        category: "GESTIÓN HUMANA",
        programadas: 1000-250,
        ejecutadas: 588+250,
        p_cumplimiento: 50,
        p_meta: 85,
      },
      {
        category: "GESTIÓN Y DESARROLLO HUMANO",
        programadas: 1200-250,
        ejecutadas: 1800+250,
        p_cumplimiento: 40,
        p_meta: 85,
      },
      {
        category: "SALUD OCUPACIONAL",
        programadas: 850-250,
        ejecutadas: 1230+250,
        p_cumplimiento: 15,
        p_meta: 85,
      },
      {
        category: "SEGURIDAD Y SALUD EN EL TRABAJO",
        programadas: 1000+150,
        ejecutadas: 588+150,
        p_cumplimiento: 5,
        p_meta: 85,
      }
    ],

  }),
  computed: {},
  mounted() {
    this.traerCapaAsis();
    // this.crearGrafico();
  },
  methods: {
    traerCapaAsis(){
      const yo = this
      yo.loading = true

      const config = {
        method: 'get',
        url: '/capacitacion/capacitaciones/'
      }

      axiosIns(config)
          .then(function (response) {
            if(response.status === 200){
              yo.items = response.data

              yo.empresaFiltro = []
              yo.sedeFiltro = []
              yo.area_responsableFiltro = []

              for (let value of yo.items){
                if(value.empresa !== null && value.empresa !== '' && value.empresa !== ' ' && value.empresa !== '  ') { yo.empresaFiltro.push(value.empresa) }
                if(value.sede !== null && value.sede !== '' && value.sede !== ' ' && value.sede !== '  ') { yo.sedeFiltro.push(value.sede) }
                if(value.planilla !== null && value.planilla !== '' && value.planilla !== ' ' && value.planilla !== '  ') { yo.planillaFiltro.push(value.planilla) }
                if(value.unidad !== null && value.unidad !== '' && value.unidad !== ' ' && value.unidad !== '  ') { yo.unidadFiltro.push(value.unidad) }
                if(value.area_responsable !== null && value.area_responsable !== '' && value.area_responsable !== ' ' && value.area_responsable !== '  ') { yo.area_responsableFiltro.push(value.area_responsable) }
              }

              yo.empresaFiltro = [...new Set(yo.empresaFiltro)].sort()
              yo.sedeFiltro = [...new Set(yo.sedeFiltro)].sort()
              yo.planillaFiltro = [...new Set(yo.planillaFiltro)].sort()
              yo.unidadFiltro = [...new Set(yo.unidadFiltro)].sort()
              yo.area_responsableFiltro = [...new Set(yo.area_responsableFiltro)].sort()

              yo.itemsFiltro = yo.items

            }

          })
          .catch(function (error) {
            console.log(error);
          })
          .finally(function (){
            yo.loading = false
          })
    },
    buscar(){
      const yo = this
      let spd = yo.items

      let filt = []

      let fecha = yo.fechaFiltro
      let fechaInicio = ''
      let fechaFin = ''
      let fechaHoy = ''

      if(fecha !== null && fecha !== ''){
        fecha = fecha.split(' a ')
        yo.filtro[5].valor = [fecha]
        if(fecha.length === 1){
          const [dia, mes, anio] = fecha[0].split('/');
          fechaInicio = new Date(+anio, mes - 1, +dia);
          fechaFin = new Date(+anio, mes - 1, +dia, 23, 59, 59);
        }
        else{
          const [dia, mes, anio] = fecha[0].split('/');
          const [dia1, mes1, anio1] = fecha[1].split('/');
          fechaInicio = new Date(+anio, mes - 1, +dia);
          fechaFin = new Date(+anio1, mes1 - 1, +dia1);
        }
      }else{
        yo.filtro[5].valor = []
        yo.fechaFiltro = null
      }

      for(const values of yo.filtro){
        console.log(values)
        for ( const column of values.valor ){
          spd.forEach(function(value) {
            if(values.nombre === 'fecha' && column !== null && value.fecha !== null){
              const [anios, mess, dias] = value.fecha.split('-')
              fechaHoy = new Date(+anios, mess - 1, +dias)

              if (fechaInicio !== '' && fechaFin !== ''){
                if(fechaHoy.getTime() >= fechaInicio.getTime() && fechaHoy.getTime() <= fechaFin.getTime()){
                  filt.push(value)
                }
              }

            }else{
              if (value[values.nombre] === column){
                filt.push(value)
              }
            }
          })
        }

        if(values.valor.length > 0){
          if(values.valor[0] !== null){
            spd = filt
            filt = []
          }
        }
      }

      yo.itemsFiltro = spd



    },
    /*
    crearGrafico(){
      let root = am5.Root.new(this.$refs.chartdiv);

      root.setThemes([am5themes_Animated.new(root)]);

      let chart = root.container.children.push(
          am5xy.XYChart.new(root, {
            panX: false,
            panY: false,
            wheelX: "panX",
            wheelY: "zoomX",
            layout: root.verticalLayout
          })
      );

      // Define data
      let data = this.datos;

      // Create X-Axis
      let xAxis = chart.xAxes.push(
          am5xy.CategoryAxis.new(root, {
            renderer: am5xy.AxisRendererX.new(root, {}),
            categoryField: "category",
          })
      );
      xAxis.data.setAll(data);

      // Create Y-axis
      let yAxis = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            min: 0,
            extraMax: 0.1,
            renderer: am5xy.AxisRendererY.new(root, {})
          })
      );

      // Create Y-axis - Opposite
      let yAxisOpposite = chart.yAxes.push(
          am5xy.ValueAxis.new(root, {
            opposite: true,
            min: 0,
            extraMax: 0.1,
            renderer: am5xy.AxisRendererY.new(root, {})
          })
      );

      // Create series
      let series1 = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: "PROGRAMADAS",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "programadas",
            categoryXField: "category",
            sequencedInterpolation: true,
          })
      );

      series1.set("fill", am5.color("#227447"));
      series1.set("stroke", am5.color("#227447"));
      series1.data.setAll(data);

      // Create series
      let series2 = chart.series.push(
          am5xy.ColumnSeries.new(root, {
            name: "EJECUTADAS",
            xAxis: xAxis,
            yAxis: yAxis,
            valueYField: "ejecutadas",
            categoryXField: "category",
            sequencedInterpolation: true,
          })
      );

      series2.set("fill", am5.color("#002060"));
      series2.set("stroke", am5.color("#002060"));
      series2.data.setAll(data);

      let series3 = chart.series.push(
          am5xy.LineSeries.new(root, {
            name: "% DE CUMPLIMIENTO",
            xAxis: xAxis,
            yAxis: yAxisOpposite,
            valueYField: "p_cumplimiento",
            categoryXField: "category",
          })
      );

      series3.strokes.template.setAll({
        strokeWidth: 3,
        strokeDasharray: [3, 3],
      });

      series3.bullets.push(function () {
        return am5.Bullet.new(root, {
          sprite: am5.Label.new(root, {
            centerY: am5.p50,
            text: "{valueX}",
            populateText: true
          })
        });
      });

      series3.set("stroke", am5.color("#C00000"));
      series3.data.setAll(data);

      let series4 = chart.series.push(
          am5xy.LineSeries.new(root, {
            name: "META DE CUMPLIMIENTO",
            xAxis: xAxis,
            yAxis: yAxisOpposite,
            valueYField: "p_meta",
            categoryXField: "category",
          })
      );

      series4.strokes.template.setAll({
        strokeWidth: 3,
        strokeDasharray: [3, 5],
        templateField: "strokeSettings",
      });
      series4.set("stroke", am5.color("#F89606"));
      series4.data.setAll(data);

      // Add legend
      let legend = chart.children.push(
          am5.Legend.new(root, {
            centerX: am5.p50,
            x: am5.p50
          })
      );
      legend.data.setAll(chart.series.values);

      // Add cursor
      chart.appear(1000, 100);

      this.root = root;
    }
    */
    crearGrafico(){
      const root = am5.Root.new(this.$refs.chartdiv)

      root.setThemes([
        am5themes_Animated.new(root)
      ]);

      const chart = root.container.children.push(am5xy.XYChart.new(root, {
        panX: false,
        panY: false,
        wheelX: 'panX',
        wheelY: 'zoomX',
        layout: root.verticalLayout
      }))

      const data = [
          {
        year: '2017',
        income: 23.5,
        expenses: 18.1
      }, {
        year: '2018',
        income: 26.2,
        expenses: 22.8
      }, {
        year: '2019',
        income: 30.1,
        expenses: 23.9
      }, {
        year: '2020',
        income: 29.5,
        expenses: 25.1
      }, {
        year: '2021',
        income: 24.6,
        expenses: 25
      }
      ]

      const xAxis = chart.yAxes.push(am5xy.CategoryAxis.new(root, {
        categoryField: 'year',
        renderer: am5xy.AxisRendererX.new(root, {
          inversed: true,
          cellStartLocation: 0.1,
          cellEndLocation: 0.9
        })
      }))

      xAxis.data.setAll(data);

      const yAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
        min: 0,
        renderer: am5xy.AxisRendererY.new(root, {}),
        extraMax: 0.1,
      }))

      const series = chart.series.push(am5xy.ColumnSeries.new(root, {
        name: 'Income',
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: 'income',
        categoryYField: 'year',
        sequencedInterpolation: true,
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: 'horizontal',
          labelText: '[bold]{name}[/]\n{categoryY}: {valueX}'
        })
      }))

      series.columns.template.setAll({
        height: am5.p100
      });

      series.bullets.push(function() {
        return am5.Bullet.new(root, {
          locationX: 1,
          locationY: 0.5,
          sprite: am5.Label.new(root, {
            centerY: am5.p50,
            text: "{valueX}",
            populateText: true
          })
        });
      });

      series.bullets.push(function() {
        return am5.Bullet.new(root, {
          locationX: 1,
          locationY: 0.5,
          sprite: am5.Label.new(root, {
            centerX: am5.p100,
            centerY: am5.p50,
            text: "{name}",
            fill: am5.color(0xffffff),
            populateText: true
          })
        });
      });

      series.data.setAll(data);
      series.appear();

      const series2 = chart.series.push(am5xy.ColumnSeries.new(root, {
        name: 'Expenses',
        xAxis: xAxis,
        yAxis: yAxis,
        valueXField: 'expenses',
        categoryYField: 'year',
        sequencedInterpolation: true,
        tooltip: am5.Tooltip.new(root, {
          pointerOrientation: 'horizontal',
          labelText: '[bold]{name}[/]\n{categoryY}: {valueX}'
        })
      }))

      series2.columns.template.setAll({
        height: am5.p100
      });

      series2.bullets.push(function() {
        return am5.Bullet.new(root, {
          locationX: 1,
          locationY: 0.5,
          sprite: am5.Label.new(root, {
            centerY: am5.p50,
            text: "{valueX}",
            populateText: true
          })
        });
      });

      series2.bullets.push(function() {
        return am5.Bullet.new(root, {
          locationX: 1,
          locationY: 0.5,
          sprite: am5.Label.new(root, {
            centerX: am5.p100,
            centerY: am5.p50,
            text: "{name}",
            fill: am5.color(0xffffff),
            populateText: true
          })
        });
      });

      series2.data.setAll(data);
      series2.appear();

      const legend = chart.children.push(am5.Legend.new(root, {
        centerX: am5.p50,
        x: am5.p50
      }))

      legend.data.setAll(chart.series.values);

      const cursor = chart.set('cursor', am5xy.XYCursor.new(root, {
        behavior: 'zoomY'
      }))
      cursor.lineY.set("forceHidden", true);
      cursor.lineX.set("forceHidden", true);

      chart.appear(1000, 100);
    }
  },
  beforeDestroy() {
    if (this.root) {
      this.root.dispose();
    }
  }
}
</script>

<style lang="scss">
  @import '@core/scss/vue/libs/vue-select.scss';
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  .hello {
    width: 100%;
    height: 400px;
  }
</style>
